import { createApi } from "@reduxjs/toolkit/query/react";

import { TclaimsApproved } from "@/interfaces/claims.interface";
import { ReportData, TippingRecordType } from "@/interfaces/interfaces";
import { BaseWithAuth, getToken, getWorkspace } from "@/utils/helpers";

export const reportsApi = createApi({
  reducerPath: "reportsApi",
  baseQuery: BaseWithAuth(),
  tagTypes: [
    "ongoing",
    "completed",
    "archive",
    "waste-management-summary",
    "task-breakdown",
  ],
  endpoints: (builder) => ({
    getTippingRecord: builder.query<
      TippingRecordType[],
      { projectId: string; dailyReportId?: string }
    >({
      query: ({ projectId, dailyReportId }) => ({
        url: `workspace/${getWorkspace()}/report/project/${projectId}/tipping-records${dailyReportId ? `?dayReportId=${dailyReportId}` : ""}`,
        headers: {
          Authorization: `Bearer ${getToken()}`,
          projectId,
        },
      }),
      providesTags: ["ongoing", "completed", "archive"],
      transformResponse: (response: APIResponse<TippingRecordType[]>) =>
        response?.data,
    }),
    addReport: builder.mutation<object, { data: object }>({
      query: ({ data }) => ({
        url: `workspace/${getWorkspace()}/report/daily`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "ongoing",
        "completed",
        "archive",
        "waste-management-summary",
      ],
    }),
    getReportData: builder.query<
      GeneralResponse<ReportData[]> | GeneralSingleResponse<ReportData>,
      string
    >({
      query: (filters) => ({
        url: `workspace/${getWorkspace()}/report/daily${filters ? filters : ""}`,
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
      providesTags: ["ongoing", "completed", "archive"],
      // transformResponse: (response: APIResponse<ReportData[]>) =>
      //   response?.data,
    }),
    deleteReport: builder.mutation<object, string>({
      query: (id) => ({
        url: `workspace/${getWorkspace()}/report/daily/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        "ongoing",
        "completed",
        "archive",
        "waste-management-summary",
      ],
    }),

    updateReport: builder.mutation<object, { data: object; id: string }>({
      query: ({ data, id }) => ({
        url: `workspace/${getWorkspace()}/report/daily/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [
        "ongoing",
        "completed",
        "archive",
        "waste-management-summary",
      ],
    }),
    getDailyReportTaskBreakDown: builder.query<
      TclaimsApproved[],
      { projectId: string; customerId: string }
    >({
      query: ({ customerId, projectId }) => ({
        url: `workspace/${getWorkspace()}/report/daily/task-breakdown?customerId=${customerId}&projectId=${projectId}`,
      }),
      transformResponse: (response: APIResponse<TclaimsApproved[]>) =>
        response?.data,
    }),
  }),
});

export const {
  useGetTippingRecordQuery,
  useAddReportMutation,
  useGetReportDataQuery,
  useDeleteReportMutation,
  useUpdateReportMutation,
  useGetDailyReportTaskBreakDownQuery,
} = reportsApi;
